module.exports = __webpack_public_path__ + "img/adv3.af9c7f39.png";